if (!customElements.get('wlsn-buybox-quantity-pill')) {
  class WLSNBuyboxQuantityPill extends HTMLElement {
    constructor() {
      super();
      this.boundHandleClick = this._handleClick.bind(this);
      this.boundHandleKeydown = this._handleKeydown.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.boundHandleClick);
      this.addEventListener('keydown', this.boundHandleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundHandleClick);
      this.removeEventListener('keydown', this.boundHandleKeydown);
    }

    /**
     * Dispatch a select event bubbling up to wlsn-buybox-quantity-selector
     */
    _select() {
      const { value, variantId } = this.dataset;
      if (value == null) return;
      this.dispatchEvent(
        new CustomEvent('wlsn:buybox-quantity-pill:select', {
          bubbles: true,
          detail: { quantity: Number(value), variantId },
        })
      );
    }

    _handleClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this._select();
    }

    _handleKeydown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this._select();
      }
    }
  }

  customElements.define('wlsn-buybox-quantity-pill', WLSNBuyboxQuantityPill);
}

if (!customElements.get('wlsn-buybox-quantity-selector')) {
  class WLSNBuyboxQuantitySelector extends HTMLElement {
    constructor() {
      super();
      this.boundHandleSelect = this._handleSelect.bind(this);
    }

    get elements() {
      const form = this.closest('wlsn-product-form');
      return {
        quantityInput: this.querySelector('input[name="quantity"]'),
        variantIdInput: form ? form.querySelector('input[name="id"]') : null,
        pills: Array.from(this.querySelectorAll('.js-quantity-pill')),
      };
    }

    connectedCallback() {
      this.addEventListener('wlsn:buybox-quantity-pill:select', this.boundHandleSelect);
      this._syncFromActivePill();
    }

    disconnectedCallback() {
      this.removeEventListener('wlsn:buybox-quantity-pill:select', this.boundHandleSelect);
    }

    /**
     * On load, fire sync for whichever pill already has .active so the
     * product-form JS starts with the correct quantity / variant state.
     */
    _syncFromActivePill() {
      const { pills } = this.elements;
      const activePill = pills.find((p) => p.classList.contains('active'));
      if (!activePill) return;
      const { value, variantId } = activePill.dataset;
      if (value == null) return;
      this._sync(Number(value), variantId);
    }

    _setActivePill(pill) {
      const { pills } = this.elements;
      pills.forEach((p) => {
        p.classList.remove('active');
        p.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('active');
      pill.setAttribute('aria-pressed', 'true');
    }

    /**
     * Update the variant-id input and fire change events so wlsn-product-form.js
     * recalculates prices. Cart quantity is always 1 — the variant itself encodes
     * the bag count, so we never multiply the price by quantity here.
     */
    _sync(quantity, variantId) {
      const { variantIdInput } = this.elements;

      if (variantIdInput && variantId != null) {
        variantIdInput.value = String(variantId);
        variantIdInput.dispatchEvent(new Event('input', { bubbles: true }));
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    _handleSelect(e) {
      const { quantity, variantId } = e.detail;
      const { pills } = this.elements;
      const pill = pills.find((p) => p === e.target);
      if (pill) this._setActivePill(pill);
      this._sync(quantity, variantId);
    }
  }

  customElements.define('wlsn-buybox-quantity-selector', WLSNBuyboxQuantitySelector);
}
